import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import CustomTableWithPagination from "@components/CustomTableWithPagination";
import Typography from "@components/Typography";
import clsx from "clsx";
import trades from "@api/trades";
import { useParams } from "react-router-dom";
import PriceFormat from "@components/PriceFormat";
import { recentMarketTime } from "@core/utils/IntervalApiTime";
import { useRangerOptional } from "@context/rangerContext";
import { formatDisplayDateTime } from "@core/helper/formatDisplayDateTime";

const RecentMarketTrades = ({ className }) => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const ranger = useRangerOptional();
  const useWs = Boolean(ranger?.enabled);
  const [state, setState] = useState({
    data: [],
    is_fetch: false,
  });

  useEffect(() => {
    if (!useWs || !currencyName || !ranger?.subscribeMarket) return undefined;
    ranger.subscribeMarket(currencyName);
    return () => ranger.unsubscribeMarket?.();
  }, [useWs, currencyName, ranger?.subscribeMarket, ranger?.unsubscribeMarket]);

  useEffect(() => {
    if (useWs && ranger?.connected) {
      setState({
        data: ranger.trades || [],
        is_fetch: true,
      });
      return undefined;
    }

    let timerToClear = null;
    (function fetch() {
      trades
        .getRecentMarkets({
          params: {
            market: currencyName?.replace("-", "_"),
          },
        })
        .then((data) => {
          setState((prevState) => ({
            ...prevState,
            data: data.content,
            is_fetch: true,
          }));
        })
        .catch((data) => {
          console.log(data);
        });

      timerToClear = setTimeout(fetch, recentMarketTime * 1000);
    })();

    return () => clearTimeout(timerToClear);
  }, [currencyName, useWs, ranger?.connected, ranger?.trades]);

  const handleChange = (event, page) => {
    setState((prevState) => ({
      ...prevState,
      is_fetch: false,
      pageNumber: page - 1,
    }));
  };

  const TableOption = [
    {
      name: "created",
      title: __t("time"),
      date: true,
      render: (record) => (
        <Typography variant="3xs" className={classes.date}>
          {formatDisplayDateTime(record.time, { pattern: "full", input: "unixSec" })}
        </Typography>
      ),
    },

    {
      name: "side",
      title: __t("To order"),
      render: (record) => (
        <div className={classes.orderTypeWrapper}>
          {String(record.side).toLowerCase() === "sell" ? (
            <span className={clsx("icon-arrow-up", classes.orderTypeIconUp)} />
          ) : (
            <span
              className={clsx("icon-arrow-down", classes.orderTypeIconDown)}
            />
          )}

          <Typography variant="3xs">{__t(record.side)}</Typography>
        </div>
      ),
    },
    {
      title: __t("amount"),
      render: (record) => {
        return <Typography variant="3xs">{record.amount}</Typography>;
      },
    },
    {
      name: "unitPrice",
      title: __t("price (toman)"),
      render: (record) => (
        <Typography variant="3xs">
          <PriceFormat price={record.unitPrice} />
        </Typography>
      ),
    },
  ];
  return (
    <>
      <CustomTableWithPagination
        TableOption={TableOption}
        data={state.data}
        is_fetch={state.is_fetch}
        handleChange={handleChange}
        className={className}
      />
    </>
  );
};

export default RecentMarketTrades;
